import * as yup from "yup";

export const remarksValidation = yup.object().shape({
  status: yup.string().required("Status is required"),
  remark: yup.string().required("Remark is required"),
});
